import { validators } from '../../utils/validators';

const validate = (values, props) => {
    const { REQUIRE } = validators;
    const errors = {};
    const isNumber = number => !/^[0-9]+([,.][0-9]{1,2})?$/g.test(number);

    if (
        REQUIRE(values.refundAmount) ||
        values.refundAmount <= 0 ||
        isNumber(values.refundAmount)
    ) {
        errors.refundAmount =
            'Please enter value greater than 0 and up to 2 decimals';
    } else if (Number(values.refundAmount) > Number(props.data.amount)) {
        errors.refundAmount =
            'Please enter refund amount less than total amount';
    }
    return errors;
};

export default validate;
